import React from 'react';

export interface CheckboxGroupContextType {
  /**
   * If `true`, all the checkboxes within the group will be disabled, preventing user interaction.
   * @default false
   */
  disabled?: boolean;
  /**
   * If `true`, all the checkboxes within the group will be read-only,
   * preventing the user from changing the value but allowing them to interact with the component.
   * @default false
   */
  readOnly?: boolean;
}

export const CheckboxGroupContext = React.createContext<CheckboxGroupContextType | null>(null);
